module.exports = "<div class=\"row\">\r\n  <div class=\"col-md-10\">\r\n    <app-clients></app-clients>\r\n  </div>\r\n  <div class=\"col-md-2\">\r\n    <app-sidebar></app-sidebar>\r\n  </div>\r\n</div>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dashboard/dashboard.component.html
// module id = ./src/app/components/dashboard/dashboard.component.html
// module chunks = main